import type { WalletPaymentChannel } from '../../features/wallet/api.ts';

/** Pick only a channel that belongs to the account's local fiat currency. */
export function firstLocalFiatChannel(
  channels: WalletPaymentChannel[] | undefined,
  fiatCurrency: string,
): WalletPaymentChannel | undefined {
  const currency = String(fiatCurrency || '').toUpperCase();
  const rows = (channels || []).filter((channel) =>
    String(channel.asset || '').toUpperCase() === currency && channel.status === 'enabled');
  return rows[0];
}

/** An unavailable channel list must never invent a payment route. */
export function localDepositFallback(_countryCode: string, _fiatCurrency: string): WalletPaymentChannel | undefined {
  return undefined;
}

/** Only configured tiers are offered; a missing configuration never invents amounts. */
export function depositQuickAmounts(minAmount: number, maxAmount: number, configured: number[] = []): number[] {
  return [...new Set(configured.map(Number))].filter(amount => Number.isFinite(amount) && amount >= minAmount && amount <= maxAmount);
}
export function validCashierAmount(amount: number, channel: Partial<WalletPaymentChannel> | undefined): boolean {
  const precision = channel?.amountPrecision ?? 2;
  const scaled=amount * 10 ** precision;
  const step=Number(channel?.amountStep || 0.01);
  if (!Number.isFinite(amount)||amount <= 0||Math.abs(scaled-Math.round(scaled))>1e-7) return false;
  if (channel?.allowCustomAmount === false) return (channel.quickAmounts || []).some(v=>Number(v)===amount);
  return Math.abs(amount/step-Math.round(amount/step))<1e-7;
}

/** Internal routing metadata is operational detail and must never be shown to players. */
export function isInternalPaymentChannel(channel: {
  channelId?: string;
  label?: string;
  network?: string;
} | null | undefined): boolean {
  return [channel?.channelId, channel?.label, channel?.network]
    .some((value) => String(value || '').toLowerCase().includes('internal'));
}
